<template lang="pug">
  section.section-content.section-content--recent-location
    .box.w-full
      header.box__header.no-border.flex.items-center.justify-between
        .header-meta
          h2.subheading Recent Location
        .header-cta
      .box__body.p-4
        .flex.flex-wrap(
          v-if="load_data_status_overall_data_location.status === 'loading'"
          class="lg:-mx-2"
        )
          Loading(show="true")
        .flex.flex-wrap(v-else class="lg:-mx-2")
          .flex.flex-wrap(class="w-full lg:w-5/12 lg:px-2")
            .w-full.border-b.border-blue-900.pb-4.mb-4.mr-8
              .flex.items-center
                .block.flex-grow
                  span.text-light.text-xs.block
                    | MSISDN
                  strong.monospace.text-base
                    | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties && overall_data_location.recent_location.features[0].properties.msisdn && overall_data_location.recent_location.features[0].properties.msisdn.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.msisdn : '-' }}
                template(v-if="route_name != 'target-detail-recent-location'")
                  button.btn.btn-primary--disabled(
                    v-if="checkTarget(overall_data_location.recent_location && overall_data_location.recent_location.features && (overall_data_location.recent_location.features[0].properties.target_name && overall_data_location.recent_location.features[0].properties.target_name.toString().length === 0) ? overall_data_location.recent_location.features[0].properties.target_name.toString() : undefined)"
                    type='button'
                    v-on:click="popUpTarget = !popUpTarget"
                    disabled="disabled" style="cursor: pointer;"
                  ) Save As Target

                  span(v-else v-tooltip="'MSISDN sudah terdaftar sebagai target: '+ (overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.target_name && overall_data_location.recent_location.features[0].properties.target_name.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.target_name : '-')")
                    button.btn.btn-primary.btn-primary--disabled(disabled="disabled" style="cursor: pointer;") Save As Target

            .block(class="w-full lg:w-1/2 lg:px-2")
              .block.mb-4
                span.text-light.text-xs.block
                  | Operator
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.provider && overall_data_location.recent_location.features[0].properties.provider.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.provider : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | Signal
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.net && overall_data_location.recent_location.features[0].properties.net.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.net : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | BTS
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.bts && overall_data_location.recent_location.features[0].properties.bts.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.bts : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | Country
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.country && overall_data_location.recent_location.features[0].properties.country.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.country : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  .flex.items-center
                    | IMEI
                    span.info-subheader(v-if="overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.old_imei !== null && overall_data_location.recent_location.features[0].properties.old_imei !== 'create'" v-tooltip="'Old IMEI: '+ overall_data_location.recent_location.features[0].properties.old_imei")
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.imei && overall_data_location.recent_location.features[0].properties.imei.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.imei : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  .flex.items-center
                    | IMSI
                    span.info-subheader(v-if="overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.old_imsi !== null && overall_data_location.recent_location.features[0].properties.old_imsi !== 'create'" v-tooltip="'Old IMSI: '+ overall_data_location.recent_location.features[0].properties.old_imsi")
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.imsi && overall_data_location.recent_location.features[0].properties.imsi.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.imsi : '-' }}

              .block.mb-4
                span.text-light.text-xs.block
                  | TAC
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.tac && overall_data_location.recent_location.features[0].properties.tac.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.tac : '-' }}

            .block(class="w-full lg:w-1/2 lg:px-2")
              .block.mb-4
                span.text-light.text-xs.block
                  | Manufacture &amp; Device Series
                strong.monospace.text-base
                  //- | {{ profile_subheader.phone ? profile_subheader.phone : '-' }}
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.ttype && overall_data_location.recent_location.features[0].properties.ttype.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.ttype : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | ENB
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.enb && overall_data_location.recent_location.features[0].properties.enb.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.enb : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | CI
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.ci && overall_data_location.recent_location.features[0].properties.ci.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.ci : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | MCC
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.mcc && overall_data_location.recent_location.features[0].properties.mcc.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.mcc : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | State
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.state && overall_data_location.recent_location.features[0].properties.state.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.state : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | LAC
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.lac && overall_data_location.recent_location.features[0].properties.lac.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.lac : '-' }}
              .block.mb-4
                span.text-light.text-xs.block
                  | Date time
                strong.monospace.text-base
                  | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.dtm && overall_data_location.recent_location.features[0].properties.dtm.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.dtm : '-' }}

          .block(class="w-full lg:w-7/12 lg:px-2")
            .flex.items-center.justify-between.mb-8
              .block.flex-grow
                  span.text-light.text-xs.block
                    | Address
                  strong.monospace.text-base
                    | {{ overall_data_location.recent_location && overall_data_location.recent_location.features && overall_data_location.recent_location.features[0].properties.alamat && overall_data_location.recent_location.features[0].properties.alamat.toString().length > 0 ? overall_data_location.recent_location.features[0].properties.alamat : '-' }}
              button.btn.btn-primary(
                v-if="target_location_data.msisdn && target_location_data.msisdn.toString().length > 0 && target_location_data.target_id && target_location_data.target_id.toString().length > 0 && target_location_data.target_name && target_location_data.target_name.toString().length > 0 && target_location_data.lat && target_location_data.lat.toString().length > 0 && target_location_data.lng && target_location_data.lng.toString().length > 0"
                type='button'
                v-on:click="popupShow = !popupShow; textFocus('find-user-tactical-input');"
              ) Send Target Location
              button.btn.btn-primary.btn-primary--disabled(v-else disabled="disabled" style="cursor: pointer;") Send Target Location

            //- .box-map(:class="isAstro === 'true' ? 'map-astro' : ''")
            .box-map.map-astro
              template(v-if="overall_data_location.recent_location && Object.keys(overall_data_location.recent_location).length > 0 && mapLoaded")
                l-map(v-if="vendorMap==='osm'" :id="id" :zoom="10" :center="center" :options="options" style="height: 355px;width: 700px;")
                  l-tile-layer(:url="url" :attribution="attribution")
                  l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index")
                      l-popup(:content="location.name")
                  LeafletHeatmap(:lat-lng="latLngHeat" :max="maxHeat" :radius="radHeat" :maxZoom="10")
                gmap-map(v-else ref="mapRef" :center="center" :zoom="10" :options="options" style="width:100%; height: 100%;")
                
              NoDataAvailable(v-else)

    section(v-bind:class="{ 'section-popup--show' : popupShow}").section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center
      .section-popup__container
          .box
              .box__header.no-border
                  header.flex.items-center.justify-between
                      .header-meta
                          h2.subheading Send Target Location
                      .header-cta
                          button.btn-icon.btn-default(v-on:click="popupShow = !popupShow")
                              div.text-gray-500
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

              .box__body.p-4(style="min-height:200px")
                .flex
                    .field.relative.field--search.w-full.mb-4
                        input.field-style#find-user-tactical-input(type="text" placeholder="Search user here (write min 3 characters)" v-model="users_keyword" @keyup="searchUsers()")
                        .absolute.inset-y-0.right-0.flex.items-center.px-2(v-if="Object.keys(user_selected).length == 0")
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                        //- .text-gray-700(v-if="Object.keys(user_selected).length == 0")
                        //- template(v-if="Object.keys(user_selected).length == 0")
                        .choosen-user.absolute.w-full.h-full.flex.items-center.justify-between.px-3.rounded(v-else)
                            .flex.items-center
                                figure.w-6.h-6.mr-4
                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="ImgAvatar")
                                span.text-light.name-index {{ user_selected.name ? user_selected.name : '' }}
                            button(v-if="user_selected.name" @click="setEmptyUser" v-tooltip="'Remove user'")
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>


                            
                .flex.items-center.w-full.mb-4.mt-4.justify-center(v-if="load_data_status_users_tactical_list === 'loading'")
                    .flex.flex-wrap.items-center.justify-center
                        Spinner(show="true" size="48")

                template(v-else-if="users_tactical_list.data && users_tactical_list.data.length > 0")
                    //- .flex.items-center.w-full.mb-2.mt-4
                    strong.block.text-xs.uppercase.text-gray-600.font-bold Choose a User
                    //- .flex.items-center.w-full.mb-4
                    .target-lists.block.w-full.mb-4
                        ul
                            li.flex.items-center.justify-between.border-b.border-gray-200.p-4(
                                class="hover:bg-gray-100"
                                style="cursor: pointer;"
                                v-tooltip="'Choose this user'"
                                v-for="(user,index) in users_tactical_list.data"
                                :key="user.id"
                                @click="chooseUser(user)"
                            )
                                div.flex.items-center
                                    figure.w-6.h-6.mr-4
                                        img.w-full.h-full.object-cover.rounded-full.bg-gray-100(:src="ImgAvatar")
                                    span.text-light.name-index {{ user.name }}

                .flex.items-center.w-full.mb-4.mt-2(v-else-if="users_tactical_list.data && users_tactical_list.data.length == 0")
                    span.text-md.text-gray-700
                        | No data available.
                button.btn.btn-primary.w-full.btn-large(v-if="Object.keys(user_selected).length > 0 && target_location_data.msisdn && target_location_data.target_id && target_location_data.target_name && target_location_data.lat && target_location_data.lng && target_location_data.user_id && target_location_data.fcm_device_id" type='button' @click="sendTargetLocation()") Send Target Location
                button.btn.btn-primary.w-full.btn-large.btn-primary--disabled(v-else type='button' disabled="disabled" style="cursor: not-allowed;") Send Target Location

    section(v-bind:class="{ 'section-popup--show' : popUpTarget}").section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center
      .section-popup__container
          .box
              .box__header.no-border
                  header.flex.items-center.justify-between
                      .header-meta
                          h2.subheading Form Create Target
                      .header-cta
                          button.btn-icon.btn-default(v-on:click="popUpTarget = !popUpTarget")
                              div.text-gray-500
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>

              //- new
              .box__body.p-4(style="min-height:200px")
                .flex
                    .field.relative.field--search.w-full.mb-4
                      form(action="" method="method")
                          .field.mb-4
                              .form-group
                                  label.block.text-sm.font-bold.mb-2(for="target_name") Target Name *
                                  input.field-style(id="target_name" name="target_name" type="text" v-model="target_name" maxlength="255")
                              .error(v-if="error_target_name !== null") {{ error_target_name }}
                          .field.mb-4
                              .form-group
                                  label.block.text-sm.font-bold.mb-2(for="target_name") Operation Name *
                                  .flex.items-center.w-full.mb-4.mt-4.justify-center(v-if="load_data_status_case_management_list === 'loading'")
                                      .flex.flex-wrap.items-center.justify-center
                                          Spinner(show="true" size="48")
                                  div(v-if="case_management_list.data !== undefined && Object.keys(case_management_list.data).length > 0")
                                    multiselect(
                                        :value="casesValue",
                                        :options="case_management_list.data ? case_management_list.data : []",
                                        :multiple="true",
                                        label="operation_name",
                                        track-by="id",
                                        @input="onChange"
                                    )
                              .error(v-if="error_case_id !== null") {{ error_case_id }}
                          .field.mb-4
                              template(v-for="clue in clues")
                                .form-group.mb-2
                                    label.block.text-sm.font-bold.mb-2(for="msisdn") MSISDN *
                                    input.field-style.readonly(v-if="clue.name == 'msisdn'" id="msisdn" name="msisdn" type="text" maxlength="255" v-bind:value="clue.value" @keypress.prevent @keydown.prevent @paste.prevent)
                                template(v-for="detail in clue.detail")
                                    .form-group.mb-2
                                        label.block.text-sm.font-bold.mb-2(v-bind:for="detail.name") {{(detail.name).toUpperCase()}}
                                        input.field-style.readonly(v-if="target_location_data[detail.name] != ''" v-bind:id="detail.name" v-bind:name="detail.name" type="text" maxlength="255" v-bind:value="detail.value" @keypress.prevent @keydown.prevent @paste.prevent)
                                        input.field-style(v-else v-bind:id="detail.name" v-bind:name="detail.name" type="number" maxlength="255" v-model="detail.value" )
                                //- .form-group
                                    label.block.text-sm.font-bold.mb-2(for="imei") IMEI *
                                    input.field-style.readonly(v-if="clue.name == 'msisdn'" id="imei" name="imei" type="text" maxlength="255" v-bind:value="clue.value" @keypress.prevent @paste.prevent)
                          .field.mb-4
                              .form-group
                                  label.block.text-sm.font-bold.mb-2(for="label") Label Color
                                  //- ul.flex.items-center(name="label" v-model="label")
                                      li.mr-2(v-for="opt in labelOpt" :key="opt.key" :value="opt.key" @click="selectLabel(opt.key)")
                                          div.box-label.p-1.border.rounded-full(:class="label === opt.key ? 'border-white-900':'border-gray-200'")
                                              label(:class="[`block w-6 h-6 bg-${opt.key}-500 rounded-full`]")
                                      template(v-if="error_label !== null")
                                          li
                                  color-picker(v-model="labelValue" @input="onColorPicker")
                                  .error(v-if="error_label !== null") {{ error_label }}

                          .field.mb-4
                              .form-group
                                  label.block.text-sm.font-bold.mb-2(for="description") Description
                                  textarea.field-style(id="description" name="description" v-model="description" style="min-height: 50px;")
                              .error(v-if="error_description !== null") {{ error_description }}

                button.btn.btn-primary.w-full.btn-large(type='button' @click="createTarget()") Create Target
                //- button.btn.btn-primary.w-full.btn-large(v-if="Object.keys(user_selected).length > 0 && target_location_data.msisdn && target_location_data.target_id && target_location_data.target_name && target_location_data.lat && target_location_data.lng && target_location_data.user_id && target_location_data.fcm_device_id" type='button' @click="sendTargetLocation()") Create Target
                //- button.btn.btn-primary.w-full.btn-large.btn-primary--disabled(v-else type='button' disabled="disabled" style="cursor: not-allowed;") Create Target

</template>

<script>
import { mapState } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import moment from 'moment';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import Spinner from '@/components/Spinner.vue';
import { decrypt } from '@/util/crypto';
import Multiselect from 'vue-multiselect';
import { Slider } from 'vue-color';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
// import LeafletHeatmap from 'LeafletHeatmap'
// import LeafletHeatmap from 'vue2-leaflet-heatmap';
import LeafletHeatmap from '@/components/LeafletHeatmap.vue';
import 'leaflet.heat';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'OverallRecentLocation',
    props: ['isKey'],
    components: {
        Loading,
        NoDataAvailable,
        Spinner,
        Multiselect,
        'color-picker': Slider,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LeafletHeatmap,

    },
    data() {
        return {
            infoWindows: [],
            mapLoaded: false,
            popupShow: false,
            popUpTarget: false,
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                      featureType: 'administrative.locality',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'geometry',
                      stylers: [{color: '#263c3f'}]
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#6b9a76'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry',
                      stylers: [{color: '#38414e'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#212a37'}]
                    },
                    {
                      featureType: 'road',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#9ca5b3'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry',
                      stylers: [{color: '#746855'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'geometry.stroke',
                      stylers: [{color: '#1f2835'}]
                    },
                    {
                      featureType: 'road.highway',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#f3d19c'}]
                    },
                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#2f3948'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#d59563'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'geometry',
                      stylers: [{color: '#17263c'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#515c6d'}]
                    },
                    {
                      featureType: 'water',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#17263c'}]
                    }
                ],
            },
            // center: { 
            //     lng: parseFloat(this.$store.state.overall_recent_location.features[0].geometry.coordinates[0]),
            //     lat: parseFloat(this.$store.state.overall_recent_location.features[0].geometry.coordinates[1]),
            // },
            center: {},
            markers: [],
            places: [],
            // myLatlng: null,
            isAstro: process.env.VUE_APP_ASTRO,

            timeout: null,
            users_keyword: '',
            user_selected: {},
            ImgAvatar: require('@/assets/images/default-avatar.png'),

            target_location_data: {},
            labelOpt: [
                {key: 'green'},
                {key: 'red'},
                {key: 'purple'},
                {key: 'orange'},
                {key: 'blue'},
            ],

            //target
            photoFile: '',
            target_id: '',
            target_name: '',
            clues: [],
            label: '',
            // status: '',
            photo: '',
            case_id: [],
            description: '',
            additional_info: [],
            // error field
            error_target_name: '',
            error_clues: '',
            error_label: '',
            // error_status: '',
            error_photo: '',
            error_case_id: '',
            error_description: '',
            error_additional_info: '',
            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // openmapstreet
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            id: 'openmapstreet-recent_location',
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
            latLngHeat: [
                // [-7.782, 110.424, (3/41)],
                // [-7.824, 110.48097, (3/41)],
                // [-7.7147, 110.6167667, (5/41)],
                // [-7.7562, 110.70192, (2/41)],
                // [-7.8191, 110.389, (4/41)],
                // [-7.69522, 110.564, (1/41)],
                // [-7.69972, 110.612, (2/41)],
                // [-7.70456, 110.604, (1/41)],
                // [-7.70503, 110.612, (1/41)],
                // [-7.71075, 110.603, (1/41)],
                // [-7.71322, 110.59, (2/41)],
                // [-7.71504, 110.59896, (2/41)],
                // [-7.71532, 110.68814, (1/41)],
                // [-7.72067, 110.5803, (7/41)],
                // [-7.72186, 110.558, (8/41)],
                // [-7.72556, 110.538, (5/41)],
                // [-7.72835, 110.45319, (1/41)],
                // [-7.72992, 110.628, (6/41)],
                // [-7.73368, 110.68725, (2/41)],
                // [-7.73568, 110.61819, (2/41)],
                // [-7.73577, 110.66273, (5/41)],
                // [-7.73938, 110.536467, (1/41)],
                // [-7.74169, 110.47309, (2/41)],
                // [-7.74508, 110.524, (2/41)],
                // [-7.75022, 110.664, (3/41)],
                // [-7.75122, 110.51219, (2/41)],
                // [-7.75144, 110.49706, (3/41)],
                // [-7.75442, 110.483, (6/41)],
                // [-7.76264, 110.474, (3/41)],
                // [-7.76323, 110.637, (2/41)],
                // [-7.76464, 110.4915, (7/41)],
                // [-7.76472, 110.421, (1/41)],
                // [-7.77956, 110.431, (2/41)],
                // [-7.77958, 110.44498, (1/41)],
                // [-7.77975, 110.452, (2/41)],
                // [-7.77989, 110.414, (4/41)],
                // [-7.78147, 110.482, (39/41)],
                // [-7.78267, 110.401, (1/41)],
                // [-7.78505, 110.515, (18/41)],
                // [-7.79245, 110.407, (2/41)],
                // [-7.79721, 110.49714, (7/41)],
                // [-7.80097, 110.403, (2/41)],
                // [-7.80153, 110.409, (2/41)],
                // [-7.80577, 110.398, (2/41)],
                // [-7.80587, 110.412, (2/41)],
                // [-7.81361, 110.483, (11/41)],
                // [-7.81389, 110.382, (2/41)],
                // [-7.81449, 110.41001, (3/41)],
                // [-7.81872, 110.397, (4/41)],
                // [-7.82232, 110.46862, (5/41)],
                // [-7.82379, 110.373, (1/41)],
                // [-7.82672, 110.38464, (41/41)],
                // [-7.83583, 110.52, (3/41)],
                // [-7.84256, 110.486, (1/41)],
                // [-7.732303, 110.558427, (3/41)],
                // [-7.752614, 110.687708, (8/41)]
            ],
            maxHeat: 1.0,
            radHeat: 30,
        };
    },
    computed: {
        ...mapState([
          'load_data_status_overall_data_location',
          'load_data_status_users_tactical_list',
          'load_data_status_case_management_list',
          'overall_data_location',
          // 'overall_recent_location',
          'profile_subheader',
          'users_tactical_list',
          'case_management_list',
        ]),
        google: gmapApi,
        key() {
            return this.$route.params.key;
        },
        // isKey() {
        //     return this.key ? true : false;
        // },
        casesValue: {
            get() {
                if (!this.case_id) 
                  return null
                // console.log('=====onChange:get')
                // console.log(this.case_id)
                return this.case_id.map(value => this.findOption(value.id)).filter(value => value.id)
            },
            set(v) {
                // console.log('=====casesValue:set')
                // console.log(v)
                this.case_id=v.map(value => {
                  let rObj = {}
                  rObj['id'] = value.id
                  return rObj
                })
            }
        },
        labelValue: {
            get() {
                if (!this.label) return ''
                // console.log('=====labelValue:get')
                // console.log(this.label)
                return {
                    hex:this.label
                }
            },
            set(v) {
                // console.log('=====labelValue:set')
                // console.log(v)
                this.label=v.hex
            }
        },
        route_name() {
            // return this.$route;
            return this.$route.name;
        },
    },
    watch: {
        // load_data_status_overall_data_location(newData) {
          // console.log('watch load_data_status_overall_data_location in RecentLocationAstro')
          // console.log(newData.status)
        // },
        // overall_data_location (newData, oldData) {
        overall_data_location () {
            // Our fancy notification (2).
            // console.log('====== watch on RecentLocation.vue')
            // console.log({newData, oldData})
            this.startMap();
            this.setTargetLocationData('recent_location');
        },
        profile_subheader () {
            // this.setTargetLocationData('subheader');

            // this.setCreateTarget();
        },
        google() {},
        users_keyword(newData) {
            if (newData.length < 3)
                this.$store.commit('setUsersTacticalList', {});
        },
        key() {
            this.setEmptyTarget();
            this.target_location_data = {};
            // console.log('set empty target_location_data', this.target_location_data)
            this.setTargetLocationData('key');
        },
        popUpTarget(data) {
          // console.log(data)
          // console.log(Object.keys(this.case_management_list).length)
            if (data == true && Object.keys(this.case_management_list).length == 0) {
                // console.log('getCaseManagementList')
                this.$store.dispatch('getCaseManagementList', [100, 1]);
            }
        },
        // isKey() {},
    },
    methods: {
        setEmptyTarget() {            
             //target
            this.photoFile= ''
            this.target_id= ''
            this.target_name= ''
            this.clues= []
            this.label= ''
            this.photo= ''
            this.case_id= []
            this.description= ''
            this.additional_info= []

            this.error_target_name= ''
            this.error_clues= ''
            this.error_label= ''
            this.error_photo= ''
            this.error_case_id= ''
            this.error_description= ''
            this.error_additional_info= ''
        },
        selectLabel(key) {
            this.label = key
        },
        hideAllInfoWindows() {
            for (var i=0; i < this.infoWindows.length; i++) {
                this.infoWindows[i].close();
            }
        },
        textFocus(id) {
            // console.log(id);
            document.getElementById(id).focus();
        },
        searchUsers() {
                // clear timeout variable
                clearTimeout(this.timeout);

                var self = this;
                this.timeout = setTimeout(function () {
                    if (self.users_keyword.length > 2) {
                        self.$store.commit('setUsersTacticalList', {});
                        self.$store.dispatch('getUsersTacticalList', [30, 1, self.users_keyword]);
                    }
                }, 650);
        },
        chooseUser(user) {
            // console.log(user)
            if (!user.fcm_device_id) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'User must have FCM Device ID!',
                    // timer: 3000,
                    // onClose: document.getElementById('find-by-input').focus(),
                })
                .then(() => {
                    this.textFocus('find-user-tactical-input');
                });
                
            } else {

                this.user_selected = user;
                this.user = user.id;

                if (user.id)
                  this.target_location_data.user_id = user.id;

                if (user.fcm_device_id)
                  this.target_location_data.fcm_device_id = user.fcm_device_id;
                console.log(this.target_location_data)

                // set empty search user keyword
            }
            
            this.users_keyword = '';
        },
        setEmptyUser() {
            this.user_selected = {};
            this.user = '';

            delete this.target_location_data.user_id;
            delete this.target_location_data.fcm_device_id;

            // console.log(this.target_location_data)

            // document.getElementById('find-user-tactical-input').focus();
            this.textFocus('find-user-tactical-input');
        },
        moment: function (string, string_format, format) {
            return moment(string, string_format).format(format);
        },
        setCreateTarget(data) {
            // console.log('data')
            // console.log(data)

            if (data.target_id)
                this.target_id = data.target_id;
            // target_name
            // if (data.target_name)
                // this.target_name = data.target_name;

            if (data.msisdn) {
                this.clues = []
                this.clues.push({
                    name: 'msisdn',
                    value: data.msisdn,
                    detail: [
                        {
                            name: 'imsi',
                            value: data.imsi
                        },
                        {
                            name: 'imei',
                            // value: ''
                            value: data.imei
                        },
                    ]
                })
            }
        },
        setTargetLocationData(source=null) {
            let target_location_data = this.target_location_data;

            if (source === 'key') {
                if (this.isKey) {
                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');
                    // console.log(decrypt_data);
                    var key = decrypt_data[0];
                    var type = decrypt_data[1]; 
                    if (type === 'msisdn')
                      target_location_data.msisdn = key;
                }

            // } else if (source === 'subheader') {
            //     // msisdn, can not use this, get from param key url
            //     // if (this.profile_subheader.msisdn)
            //     //   target_location_data.msisdn = this.profile_subheader.msisdn;

            //     // target_id
            //     if (this.profile_subheader.target_id)
            //       target_location_data.target_id = this.profile_subheader.target_id;

            //     // target_name
            //     if (this.profile_subheader.target_name)
            //       target_location_data.target_name = this.profile_subheader.target_name;

            } else if (source === 'recent_location') {
                // lat
                // if (this.overall_data_location.recent_location && this.overall_data_location.recent_location.features && this.overall_data_location.recent_location.features[0].geometry.coordinates[1]) {
                //   target_location_data.lat = this.overall_data_location.recent_location.features[0].geometry.coordinates[1];
                // } else if (this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][0]) {
                //   target_location_data.lat = this.overall_data_location.heatmap[0][0];
                // }

                // // lng
                // if (this.overall_data_location.recent_location && this.overall_data_location.recent_location.features && this.overall_data_location.recent_location.features[0].geometry.coordinates[0]) {
                //   target_location_data.lng = this.overall_data_location.recent_location.features[0].geometry.coordinates[0];
                // } else if (this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][1]) {
                //   target_location_data.lng = this.overall_data_location.heatmap[0][1];
                // }

                if (this.overall_data_location.recent_location && this.overall_data_location.recent_location.features && this.overall_data_location.recent_location.features[0].properties) {
                  // lat
                  if (this.overall_data_location.recent_location.features[0].geometry.coordinates[1])
                    target_location_data.lat = this.overall_data_location.recent_location.features[0].geometry.coordinates[1];
                  // lng
                  if (this.overall_data_location.recent_location.features[0].geometry.coordinates[0])
                    target_location_data.lng = this.overall_data_location.recent_location.features[0].geometry.coordinates[0];

                  // target_id
                  if (this.overall_data_location.recent_location.features[0].properties.target_id)
                      target_location_data.target_id = this.overall_data_location.recent_location.features[0].properties.target_id;
                  // target_name
                  if (this.overall_data_location.recent_location.features[0].properties.target_name)
                      target_location_data.target_name = this.overall_data_location.recent_location.features[0].properties.target_name;

                  // address
                  if (this.overall_data_location.recent_location.features[0].properties.alamat)
                      target_location_data.address = this.overall_data_location.recent_location.features[0].properties.alamat;
                  // bts
                  if (this.overall_data_location.recent_location.features[0].properties.bts)
                      target_location_data.bts = this.overall_data_location.recent_location.features[0].properties.bts;
                  // imei
                  if (this.overall_data_location.recent_location.features[0].properties.imei)
                    target_location_data.imei = this.overall_data_location.recent_location.features[0].properties.imei;
                  // imsi
                  if (this.overall_data_location.recent_location.features[0].properties.imsi)
                    target_location_data.imsi = this.overall_data_location.recent_location.features[0].properties.imsi;
                  // mcc
                  if (this.overall_data_location.recent_location.features[0].properties.mcc)
                    target_location_data.mcc = this.overall_data_location.recent_location.features[0].properties.mcc;
                  // lac
                  if (this.overall_data_location.recent_location.features[0].properties.lac)
                    target_location_data.lac = this.overall_data_location.recent_location.features[0].properties.lac;
                  // ci
                  if (this.overall_data_location.recent_location.features[0].properties.ci)
                    target_location_data.ci = this.overall_data_location.recent_location.features[0].properties.ci;
                }
            }

            this.target_location_data = target_location_data;
            // console.log(this.target_location_data);
            if (this.target_location_data && typeof(this.target_location_data.imsi) != 'undefined') {
                this.setCreateTarget(this.target_location_data);
            }
            // console.log('set location data', this.target_location_data);
        },
        async sendTargetLocation() {
            this.showLoading(true);
            // console.log(this.target_location_data)
            await this.$store.dispatch('getSendTargetLocation', [
                (this.target_location_data.msisdn && this.target_location_data.msisdn.length > 0 ? this.target_location_data.msisdn : ''),
                (this.target_location_data.user_id && this.target_location_data.user_id.length > 0 ? this.target_location_data.user_id : ''),
                (this.target_location_data.fcm_device_id && this.target_location_data.fcm_device_id.length > 0 ? this.target_location_data.fcm_device_id : ''),
                (this.target_location_data.target_id && this.target_location_data.target_id.length > 0 ? this.target_location_data.target_id : ''),
                (this.target_location_data.target_name && this.target_location_data.target_name.length > 0 ? this.target_location_data.target_name : ''),
                (this.target_location_data.lat && this.target_location_data.lat.length > 0 ? this.target_location_data.lat : ''),
                (this.target_location_data.lng && this.target_location_data.lng.length > 0 ? this.target_location_data.lng : ''),
                (this.target_location_data.address && this.target_location_data.address.length > 0 ? this.target_location_data.address : ''),
                (this.target_location_data.bts && this.target_location_data.bts.length > 0 ? this.target_location_data.bts : ''),
                (this.target_location_data.imei && this.target_location_data.imei.length > 0 ? this.target_location_data.imei : ''),
                (this.target_location_data.imsi && this.target_location_data.imsi.length > 0 ? this.target_location_data.imsi : ''),
                (this.target_location_data.mcc && this.target_location_data.mcc.length > 0 ? this.target_location_data.mcc : ''),
                (this.target_location_data.lac && this.target_location_data.lac.length > 0 ? this.target_location_data.lac : ''),
                (this.target_location_data.ci && this.target_location_data.ci.length > 0 ? this.target_location_data.ci : ''),
                (this.target_location_data.ttype && this.target_location_data.ttype.length > 0 ? this.target_location_data.ttype : ''),
                (this.target_location_data.enb && this.target_location_data.enb.length > 0 ? this.target_location_data.enb : ''),
                (this.target_location_data.tac && this.target_location_data.tac.length > 0 ? this.target_location_data.tac : '')
            ])
            .then((result) => {
                if (result.result === 'success') {
                    this.users_keyword = '';
                    this.setEmptyUser();
                    this.popupShow = !this.popupShow;

                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success, message has been sent!',
                        // timer: 3000,
                    });
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Failed to send target location, please try again!',
                        // timer: 3000,
                    });
                }
            });
        },

        startMap() {
            switch(this.vendorMap) {
              case 'osm':
                this.startMapOSM();
                break;
              default:
                this.startMapGMAP();
                break;
            }
        },
        startMapGMAP() {
            // set empty search user tactical
            this.users_keyword = '';
            this.user_selected = {};
            this.$store.commit('setUsersTacticalList', {});

            // console.log('start Map')
            var self = this;
            var location = [];
            self.markers = [];
            self.infoWindows = [];
            // const google = self.google;

            if(typeof this.overall_data_location.recent_location !== undefined && typeof this.overall_data_location.recent_location !== 'undefined' && this.overall_data_location.recent_location !== null){
                location = this.overall_data_location.recent_location
            } else {
                return;
            }

            // if (Object.keys(location).length > 0 || Object.keys(this.overall_data_location.heatmap).length > 0) {
            if (Object.keys(location).length > 0) {
                // console.log('startMap')
                var result = Object.keys(location).length > 0 ? location.features[0] : null;

                var lng = parseFloat(result && result.geometry.coordinates[0] ? result.geometry.coordinates[0] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][1] ? this.overall_data_location.heatmap[0][1] : 0));

                var lat = parseFloat(result && result.geometry.coordinates[1] ? result.geometry.coordinates[1] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][0] ? this.overall_data_location.heatmap[0][0] : 0));
                // for marker
                // var dtm = moment().format('DD MMMM YYYY, hh:mm');
                // var dtm = (result && result.properties.dtm ? moment(result.properties.dtm, 'YYYY-MM-DDTHH:mm:ss').format('DD MMMM YYYY, HH:mm') : '-');
                var dtm = (result && result.properties.dtm ? result.properties.dtm : '-');
                
                // var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : (result && result.properties.bts ? result.properties.bts : '-'));
                var bts = (result && result.properties.bts && result.properties.bts.toString().length > 0 ? result.properties.bts : '-');
                var state = (result && result.properties.state && result.properties.state.toString().length > 0 ? result.properties.state : '-');

                // console.log('lan, lng on recent location : ');
                // console.log({lat, lng});

                var name = result ? result.properties.name : '-';
                // set_map(name, lat, lng, results.heatmap)

                if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    return;
                }

                this.center = {
                    lat: lat,
                    lng: lng,
                };
                // console.log('center :')
                // console.log(this.center)

                this.mapLoaded = true;
                // console.log('mapLoaded :')
                // console.log(this.mapLoaded)

                // ------------------------------------------------------

                // if (this.overall_data_location.heatmap == null) {
                //     this.$nextTick(() => {
                //         this.$refs.mapRef.$mapPromise.then((map) => {
                //             map.zoom = 10;
                //         });
                //     });
                // }

                // console.log('before if else map')
                // map config
                if (self.overall_data_location.heatmap != null && typeof self.overall_data_location.heatmap[0] !== 'undefined' && typeof self.overall_data_location.heatmap[0] !== undefined ) {
                    
                    // console.log('if map')

                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {
                            const google = self.google;

                            map.center = new google.maps.LatLng(self.center);
                            map.zoom = 10;

                            // eslint-disable next-line
                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(self.center),
                                map: map,
                                // title: name,
                            });
                            // console.log(marker)
                            self.markers.push(marker);

                            // var marker2 = new google.maps.Marker({
                            //     position: new google.maps.LatLng({
                            //         lat: -6.2256095,
                            //         lng: 106.7754866
                            //     }),
                            //     map: map 
                            // });
                            // self.markers.push(marker2);

                            // -------------------------
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                                  // '<p>Link Location: <strong><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'">'+
                                  // 'Google Maps</a></strong> '+
                                  // '</p>'+
                                '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1">Last Updated</td>'+
                                    '<td class="pr-1">:</td>'+
                                    '<td>'+dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>BTS</td>'+
                                    '<td>:</td>'+
                                    '<td>'+bts+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>State</td>'+
                                    '<td>:</td>'+
                                    '<td>'+state+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>Link Location</td>'+
                                    '<td>:</td>'+
                                    '<td><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';

                            const infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 300
                            });
                            
                            self.infoWindows.push(infowindow);

                            // -------------------------
                            // var contentString2 = '<div id="content">'+
                            //       '<div id="bodyContent">'+
                            //       '<p>Link Location 2: <strong><a target="_blank" href="https://www.google.com/maps?q='+-6.2256095+','+106.7754866+'">'+
                            //       'Google Maps</a></strong> '+
                            //       '</p>'+
                            //       '</div>'+
                            //       '</div>';

                            // const infowindow2 = new google.maps.InfoWindow({
                            //     content: contentString2,
                            //     maxWidth: 200
                            // });
                            
                            // self.infoWindows.push(infowindow2); 
                            
                            google.maps.event.addListener(marker, 'click', function() {
                              // self.hideAllInfoWindows(map);
                              self.hideAllInfoWindows();
                              infowindow.open(map, marker);
                            });

                            // google.maps.event.addListener(marker2, 'click', function() {
                            //   // self.hideAllInfoWindows(map);
                            //   self.hideAllInfoWindows();
                            //   infowindow2.open(map, marker2);
                            // });
                            // -------------------------

                            var heatmapData = [];
                            self.overall_data_location.heatmap.forEach(function(coord) {
                                heatmapData.push(new google.maps.LatLng(coord[0], coord[1]));
                            });

                            var setHeatmap = new google.maps.visualization.HeatmapLayer({
                              data: heatmapData,
                              map: map
                            });

                            var bounds = new google.maps.LatLngBounds();

                            // Extend bounds with each point
                            for (var i = 0; i < heatmapData.length; i++) {
                                bounds.extend(heatmapData[i]);
                            }

                            // add marker to bounds
                            bounds.extend(new google.maps.LatLng(self.center.lat, self.center.lng));

                            // Apply fitBounds
                            map.fitBounds(bounds);

                            setHeatmap.setMap(map);
                            setHeatmap.set('radius', 30);
                        });
                    });
                } else {
                    // console.log('else map')

                    self.$nextTick(() => {
                        self.$refs.mapRef.$mapPromise.then((map) => {
                            const google = self.google;

                            // map.center = self.myLatlng;
                            map.center = new google.maps.LatLng(self.center);
                            map.zoom = 10;

                            var marker = new google.maps.Marker({
                                position: new google.maps.LatLng(self.center),
                                // position: self.myLatlng,
                                map: map,
                                title: name,
                            });

                            // console.log(name)
                            
                            // marker.setMap(map);
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                                  // '<div id="bodyContent">'+
                                  // '<p>Link Location: <a target="_blank" href="https://www.google.com/maps?q='+lat+','+lng+'">'+
                                  // 'Google Maps</a> '+
                                  // '</p>'+
                                '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1">Last Updated</td>'+
                                    '<td class="pr-1">:</td>'+
                                    '<td>'+dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>BTS</td>'+
                                    '<td>:</td>'+
                                    '<td>'+bts+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>State</td>'+
                                    '<td>:</td>'+
                                    '<td>'+state+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td>Link Location</td>'+
                                    '<td>:</td>'+
                                    '<td><a target="_blank" href="https://www.google.com/maps?q='+lat+','+lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';

                            var infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 300,
                            });

                            self.infoWindows.push(infowindow);
                            
                            // marker.addListener('click', function() {
                            google.maps.event.addListener(marker, 'click', function() {
                                infowindow.open(map, marker);
                            });
                        });
                    });
                }
            }
        },
        startMapOSM() {
            // console.log('start Map')
            var self = this;
            var location = [];
            self.locations = [];
            self.latLngHeat = [];
            // const google = self.google;

            if(typeof this.overall_data_location.recent_location !== undefined && typeof this.overall_data_location.recent_location !== 'undefined' && this.overall_data_location.recent_location !== null){
                location = this.overall_data_location.recent_location
            } else {
                return;
            }

            if (Object.keys(location).length > 0 || Object.keys(this.overall_data_location.heatmap).length > 0) {
                

                var result = Object.keys(location).length > 0 ? location.features[0] : null;

                var lng = parseFloat(result && result.geometry.coordinates[0] ? result.geometry.coordinates[0] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][1] ? this.overall_data_location.heatmap[0][1] : 0));

                var lat = parseFloat(result && result.geometry.coordinates[1] ? result.geometry.coordinates[1] : (this.overall_data_location && this.overall_data_location.heatmap && this.overall_data_location.heatmap[0] && this.overall_data_location.heatmap[0][0] ? this.overall_data_location.heatmap[0][0] : 0));

                // for marker
                // var dtm = moment().format('DD MMMM YYYY, hh:mm');
                var dtm = (result && result.properties.dtm ? result.properties.dtm : '-');
                // var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : '-');
                var bts = (this.overall_data_location.data_location && this.overall_data_location.data_location.bts ? this.overall_data_location.data_location.bts : (result && result.properties.bts ? result.properties.bts : '-'));
                var state = (result && result.properties.state ? result.properties.state : '-');

                // console.log('lan, lng on recent location : ');
                // console.log({lat, lng});

                // var name = result ? result.properties.name : '-';
                // set_map(name, lat, lng, results.heatmap)

                if (Number.isNaN(lat) || Number.isNaN(lng)) {
                    return;
                }

                this.center = {
                    lat: lat,
                    lng: lng,
                };
                // console.log('center :')
                // console.log(this.center)

                this.mapLoaded = true;
                // console.log('mapLoaded :')
                // console.log(this.mapLoaded)

                // ------------------------------------------------------

                // if (this.overall_data_location.heatmap == null) {
                //     this.$nextTick(() => {
                //         this.$refs.mapRef.$mapPromise.then((map) => {
                //             map.zoom = 10;
                //         });
                //     });
                // }

                // console.log('before if else map')
                // map config
                var contentString = '<div id="content">'+
                  '<div id="bodyContent">'+
                    '<table>'+
                      '<tr>'+
                        '<td class="pr-1">Last Updated</td>'+
                        '<td class="pr-1">:</td>'+
                        '<td>'+dtm+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>BTS</td>'+
                        '<td>:</td>'+
                        '<td>'+bts+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>State</td>'+
                        '<td>:</td>'+
                        '<td>'+state+'</td>'+
                      '</tr>'+
                      '<tr>'+
                        '<td>Link Location</td>'+
                        '<td>:</td>'+
                        '<td><a target="_blank" href="https://www.google.com/maps?q='+self.center.lat+','+self.center.lng+'" style="color: #43ea92;">'+'Google Maps</a> '+
                        '</td>'+
                      '</tr>'+
                    '</table>'+
                  '</div>'+
                '</div>';
                let centerTmp = [self.center['lat'], self.center['lng']]
                self.locations.push({name:contentString,position:centerTmp})
                if (self.overall_data_location.heatmap != null && typeof self.overall_data_location.heatmap[0] !== 'undefined' && typeof self.overall_data_location.heatmap[0] !== undefined ) {
                    var heatmapData = {};
                    var maxValue = 0;
                    var heatmapDataFix = []
                    self.overall_data_location.heatmap.forEach(function(coord) {
                        // var arr = [coord[0], coord[1], 0.1];
                        // heatmapDataFix.push(arr)
                        if(heatmapData[coord[0]+','+coord[1]]){
                            heatmapData[coord[0]+','+coord[1]][2] += 1;
                        } else {
                            heatmapData[coord[0]+','+coord[1]]= [coord[0], coord[1], 1];
                        }
                        if (maxValue<heatmapData[coord[0]+','+coord[1]][2]){
                            maxValue = heatmapData[coord[0]+','+coord[1]][2]
                        }
                    });
                    // console.log({heatmapData})
                    // if (heatmapData.length){
                    if (maxValue>0){
                        Object.values(heatmapData).forEach(function(arr) {
                            arr[2] = arr[2]/maxValue
                            heatmapDataFix.push(arr)
                        });
                        // console.log({heatmapDataFix})
                        self.latLngHeat = heatmapDataFix
                    }
                }
            }
        },
        checkTarget(name){
            // console.log(name.length)
            if(name) {
                var res = name.split(" ")
                // console.log('res.length')
                // console.log(res.length)
                if(res.length > 1){
                    // if (res[0].toLowerCase() == 'target' && res[1] == this.profile_subheader.msisdn) {
                    var msisdn = (this.overall_data_location.recent_location && this.overall_data_location.recent_location.features && this.overall_data_location.recent_location.features[0].properties.msisdn.toString().length > 0 ? this.overall_data_location.recent_location.features[0].properties.msisdn : null);
                    if (res[0].toLowerCase() == 'target' && res[1] == msisdn) {
                        return true
                    }
                    return false
                }
                return false
            } else {
                return true
            }
        },
        createTarget(){
            this.showLoading(true)
            if (this.case_id && this.case_id.length==0) {
                let err = {
                  case_id: "Field Operation Name must not be empty"
                }
                this.error_case_id = (err.case_id ? err.case_id : '');

                this.error(err);
                return;
            }
            if (this.target_id) {
                this.$store.dispatch('getSingleTargetUpdate', [this.target_id, this.target_name, [JSON.stringify(this.clues)], this.label, this.photoFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])// this.status,
                .then((resp) => {
                    this.showLoading(false)
                    if (resp.result === 'success') {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                        try {
                            this.overall_data_location.recent_location.features[0].properties.target_name = this.target_name
                        } catch (error) {
                            console.log(error)
                        }
                        this.popUpTarget = !this.popUpTarget
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_target_name = (resp.data.message.errors.target_name ? resp.data.message.errors.target_name : '');
                            this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_case_id = (resp.data.message.errors.case_id ? resp.data.message.errors.case_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');
                            this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            } else {
                this.$store.dispatch('getSingleTargetCreate', [this.target_name, [JSON.stringify(this.clues)], this.label, this.photoFile, [JSON.stringify(this.case_id)], this.description, [JSON.stringify(this.additional_info)]])// this.status,
                .then((resp) => {
                    this.showLoading(false)
                    if (resp.result === 'success') {
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully created!',
                            timer: 3000,
                        });
                        try {
                            this.overall_data_location.recent_location.features[0].properties.target_name = this.target_name
                        } catch (error) {
                            console.log(error)
                        }
                        this.popUpTarget = !this.popUpTarget
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error_target_name = (resp.data.message.errors.target_name ? resp.data.message.errors.target_name : '');
                            this.error_clues = (resp.data.message.errors.clues ? resp.data.message.errors.clues : '');
                            this.error_label = (resp.data.message.errors.label ? resp.data.message.errors.label : '');
                            // this.error_status = (resp.data.message.errors.status ? resp.data.message.errors.status : '');
                            this.error_photo = (resp.data.message.errors.photo ? resp.data.message.errors.photo : '');
                            this.error_case_id = (resp.data.message.errors.case_id ? resp.data.message.errors.case_id : '');
                            this.error_description = (resp.data.message.errors.description ? resp.data.message.errors.description : '');
                            this.error_additional_info = (resp.data.message.errors.additional_info ? resp.data.message.errors.additional_info : '');

                            this.error(resp.data.message.errors);
                        } else {
                            this.error();
                        }
                    }
                });
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
        onChange (value) {
            this.casesValue = value
        },
        onColorPicker(value) {
            this.labelValue = value
        },
        findOption(value) {
            // console.log('=====findOption')
            // console.log(value)
            const opt = this.case_management_list.data
            return opt.find(option => option['id'] === value)
        },
    },
    mounted() {
        // console.log('=============== mounted on RecentLocation.vue')
        // console.log(this.isKey)
        if (this.isKey) {
            this.startMap();
            this.setTargetLocationData('key');
            // this.setCreateTarget();
        }
        // if (this.profile_subheader) {
          // this.setCreateTarget();
        // }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="sass">
.box-map
    width: 100%
    height: 355px
    display: flex
    align-items: center
    justify-content: center
    iframe
        width: 100%
        height: 100%
.box-map.map-astro
        height: 330px

</style>
